// extracted by mini-css-extract-plugin
module.exports = {"container":"Ks6aTable_container__3cssh","worksDoneLabel":"Ks6aTable_worksDoneLabel__2Lvkg","months":"Ks6aTable_months__2pE-w"};